"use client";

import {
  APP_NAME,
  APP_STORE_CALENDAR_CONTACT_WEBSITE,
  SUPPORT_MAIL_ADDRESS,
  WEBAPP_URL,
} from "@calcom/lib/constants";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useLayoutEffect } from "react";

export function NotFound({ host: _host }: { host: string }) {
  const { t } = useLocale();
  const pathname = usePathname() ?? "";
  const isBookingSuccessPage = pathname?.startsWith("/booking");

  useLayoutEffect(() => {
    if (typeof window !== "undefined") {
      window.CalComPageStatus = "404";
    }
  }, []);

  const title = isBookingSuccessPage ? t("booking_not_found") : t("page_doesnt_exist");
  const subtitle = isBookingSuccessPage
    ? t("check_spelling_mistakes_or_go_back")
    : t("check_spelling_mistakes_or_go_back");

  return (
    <div
      className="flex min-h-screen w-full flex-col items-center justify-center px-4 py-12"
      style={{
        background: "linear-gradient(165deg, #f7f9fc 0%, #e8eef8 45%, #dce8f8 100%)",
      }}
      data-testid="404-page">
      <div className="w-full max-w-[560px] overflow-hidden rounded-[1.25rem] border border-[#d8e0ec] bg-white shadow-[0_1px_2px_rgba(0,14,51,0.04),0_16px_36px_rgba(0,14,51,0.08)]">
        <div className="border-b border-[#d8e0ec] px-8 py-5">
          <Link href={APP_STORE_CALENDAR_CONTACT_WEBSITE} className="inline-flex items-center">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/cal-logo-word-black.png" alt={APP_NAME} className="h-7 w-auto" />
          </Link>
        </div>

        <div className="px-8 py-10 text-center sm:px-10">
          <p
            className="text-sm font-semibold tracking-[0.12em] uppercase"
            style={{ color: "#007BFF" }}>
            {t("error_404")}
          </p>
          <h1 className="font-cal mt-3 text-[1.75rem] leading-tight tracking-tight text-[#000E33] sm:text-[2rem]">
            {title}
          </h1>
          <p className="mx-auto mt-3 max-w-[36ch] text-base leading-relaxed text-[#5a6a84]">{subtitle}</p>

          <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:justify-center">
            <Link
              href={APP_STORE_CALENDAR_CONTACT_WEBSITE}
              className="inline-flex items-center justify-center rounded-[10px] bg-[#000E33] px-5 py-2.5 text-sm font-medium text-white transition hover:bg-[#001a4d]">
              {t("go_back_home")}
            </Link>
            <Link
              href={`${WEBAPP_URL}/auth/login`}
              className="inline-flex items-center justify-center rounded-[10px] border border-[#d8e0ec] bg-white px-5 py-2.5 text-sm font-medium text-[#000E33] transition hover:border-[#b8c5d8] hover:bg-[#f4f6fa]">
              {t("sign_in")}
            </Link>
          </div>

          <p className="mt-8 text-sm text-[#8b98ad]">
            <a
              href={`mailto:${SUPPORT_MAIL_ADDRESS}`}
              className="font-medium text-[#007BFF] underline-offset-2 hover:underline">
              {SUPPORT_MAIL_ADDRESS}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
